import { useEffect, useState } from 'react';
import { MOBILE_MAX_WIDTH } from '../constants/breakpoints';

/**
 * A hook that returns whether the viewport is in mobile size or not.
 * @param mobileBreakpoint - The max width in pixels to consider as mobile. Default is MOBILE_MAX_WIDTH (991), matching the SCSS mobile breakpoint.
 * @returns boolean indicating if the viewport is in mobile size
 */
const useIsMobile = (mobileBreakpoint = MOBILE_MAX_WIDTH): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= mobileBreakpoint);
    };

    // Initial check
    checkMobile();

    // Add event listener
    window.addEventListener('resize', checkMobile);

    // Cleanup
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, [mobileBreakpoint]);

  return isMobile;
};

export default useIsMobile; 